<template>
    <div class="d-flex flex-column gap-4 pb-4 border-bottom border-2">
        <div>
            <nuxt-link 
                :to="$prismic.linkResolver(item.document)" 
                class="text-dark text-primary-hover"
            >
                <prismic-image 
                    :img="item.image"
                    :alt="item.document.data.title"
                    w="100"
                    class="float-end ms-2"
                />
                <span class="h3 text-dark">{{ index + 1 }}.</span>
                <h3 class="text-reset d-inline">{{ item.h3 }}</h3>
            </nuxt-link>
            <div 
                v-if="$validateText(item.teaser)"
                class="rich-text text-dark mt-2"
                v-html="$prismic.asHtml(item.teaser)"
            />
        </div>
        <pros-list 
            v-if="item.pros" 
            :pros="item.pros"
        />
        <table v-else class="table text-dark shadow-sm">
            <tbody>
                <tr 
                    v-for="(tableRowData, rowIndex) in item.tableData"
                    :key="rowIndex"
                    :class="{'bg-soft-secondary': rowIndex % 2 === 1}"
                >
                    <th class="fw-bold text-dark w-50 fs-6 fs-md-5">{{ tableRowData.title }}</th>
                    <td class="text-dark w-50 border-start border-1 fs-6 fs-md-5">
                        <span v-html="tableRowData.value" />
                        <Tooltip 
                            v-if="tableRowData.showTooltip" 
                            :text="tableRowData.tooltipData" 
                            icon-class="ms-1"
                        />
                    </td>
                </tr>
            </tbody>
        </table>
        <out-link
            class="btn btn-primary rounded fw-bold col-12 col-lg-3"
            :document="item.document"
            :text="$translate('cta_to_application', 'Till ansökan')"
        />
    </div>
</template>

<script>
import ProsList from '@/components/ProsList.vue';
import Tooltip from '@/components/features/Tooltip.vue';
export default {
    components: {
        ProsList,
        Tooltip
    },
    props: {
        item: {
            type: Object,
            required: true
        },
        index: {
            type: Number,
            required: true
        }
    }
};
</script>